var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeatMap9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 206,
    viewBox: "0 0 147 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_1693_53310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.51 85.2358C95.9652 68.1408 82.6683 60.3262 77.213 58.5557C66.3001 35.7457 52.0576 24.6128 46.3005 21.8977C29.5691 19.8583 27.19 11.2787 14.0206 33.1807C7.31107 60.1426 43.8954 129.792 71.2501 175.026C90.7509 192.893 102.826 192.471 110.099 190.653C127.87 186.441 130.57 173.24 130.319 164.93C132.281 144.887 125.179 125.063 118.52 115.453C117.099 105.32 109.255 91.0859 105.51 85.2358Z",
    fill: "#499FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5532 90.7509C89.4457 78.0874 79.4518 72.3503 75.3433 71.0647C67.2365 54.157 56.548 45.9567 52.2171 43.97C39.9672 36.8138 29.598 42.3317 25.9445 45.9851C12.3842 55.0105 45.2761 125.415 70.165 157.755C83.0203 175.487 97.237 177.131 102.738 175.736C116.18 172.499 119.259 159.328 119.118 153.146C120.716 138.223 111.172 120.269 106.2 113.158C105.186 105.626 99.3463 95.0818 96.5532 90.7509Z",
    fill: "#30CB87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4911 63.71C61.4755 60.9949 57.3752 58.054 55.702 56.9229C53.5567 54.2629 48.9604 52.3599 46.9304 51.7408C36.3535 50.969 31.4574 56.0137 29.7285 59.1469C23.2791 65.077 39.4983 107.258 56.0313 120.241L61.6945 130.491L67.8389 138.954C77.6925 163.092 90.8754 166.323 96.6558 167.239C111.282 166.137 113.341 155.877 112.873 146.822C110.97 124.707 101.897 112.764 95.8148 107.201L90.9069 101.609L82.2422 88.8559L72.7501 76.638L64.4911 63.71Z",
    fill: "#FFC909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.226 95.1971C82.3762 85.3615 72.8146 80.5183 68.8901 79.3262C67.5342 64.82 57.7733 50.7536 53.0623 45.5336C39.7766 28.4088 25.0361 35.6807 19.3265 41.4573C9.57329 54.4589 22.3245 83.3059 29.9192 96.1043L35.507 101.82L40.5904 108.015L50.7363 119.365L54.1525 122.348L63.0784 133.176C66.9316 145.56 78.171 156.457 83.309 160.358C92.2309 175.798 101.02 181.026 104.299 181.71C120.759 188.247 123.717 170.469 123.139 160.762C122.639 141.905 112.486 126.663 107.472 121.399C99.9323 104.944 92.1665 97.0748 89.226 95.1971Z",
    fill: "#FF2F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1693_53310",
    x: 9.21436,
    y: 14.5312,
    width: 125.437,
    height: 180.96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1693_53310"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatMap9);
export default __webpack_public_path__ + "static/media/heatMap9.8ad189afb4a8c4cdbb46fc4add9b7758.svg";
export { ForwardRef as ReactComponent };